export default {
  verify: {
    complete: {
      title: 'Email Verified',
      message: 'Thank you for verifying your email. You may close this browser tab and continue to log in.'
    },
    errors: {
      email_not_verified: 'You have not verified your email address yet.',
      email_not_unique: 'This email was used previously to create an account.',
    },
    expired: {
      title: 'Unable to Verify Email',
      message: 'We were unable to verify your email because your link has expired. For security reasons, email verification links are only valid for 3 days.',
      remedy: 'To get a fresh verification link, please log in.',
      login: 'Log In'
    },
    invalid: {
      title: 'Unable to Verify Email',
      message: 'We were unable to verify your email because your link is invalid.',
      remedy: 'To get a fresh verification link, please log in.',
      login: 'Log In'
    },
    required: {
      title: 'Verify Your Email',
      message: 'We sent a link to verify your email address to <strong>{email}</strong>. Please go to your email and click that link to verify that we have your correct email address - then return to this page and press Continue.',
      submit: 'Continue',
      noEmail: 'Didn\'t get the email? You can {resend}, but you should also make sure our email didn\'t end up in your spam folder.',
      resend: 'resend the link',
      resent: 'Email sent again.'
    },
    update: {
      title: 'Update email',
      email: 'Email',
      wrongEmail: 'Wrong email address? {update}',
      updateEmail: 'Update your email',
      details: 'Enter your email',
      update: 'Update'
    }
  }
};
